/** Mirrors GomakeDbContext.Utils.Utils.PrintHouseERP (admin service). */
export enum PrintHouseErp {
  Null = 0,
  SAP = 1,
  Hashfshifet = 2,
  Senzey = 3,
  Priority = 4,
  Accounting = 5,
  ZohoBooks = 6,
  QuickBooks = 7,
}
